import script from "./not-found-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./not-found-page.vue?vue&type=script&setup=true&lang=ts"

import "./not-found-page.vue?vue&type=style&index=0&id=d6c58d32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c58d32"]])

export default __exports__